import { render, staticRenderFns } from "./LProjectObjectModalPreview.vue?vue&type=template&id=6bd58fe4&"
import script from "./LProjectObjectModalPreview.vue?vue&type=script&lang=js&"
export * from "./LProjectObjectModalPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports